var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"medium-gauge-wrapper"},[_c('img',{attrs:{"src":_vm.gaugeSvg}}),_c('div',{staticClass:"credit-score"},[_vm._v(" "+_vm._s(_vm.gaugeScore)+" ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }